import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARITY } from "constants/api";
import axios from "utils/http";
export interface IFetchCharitiesResponse extends ApiResponse {
  data: ICharity;
}

export interface IFetchCharityDonorsResponse extends ApiResponse {
  data: ICharityDonorsList[];
}

export interface ICreateCharityResponse extends ApiResponse {
  data: ICharity;
}

export interface IFetchCharityDonorsArgs extends ReduxAction {
  id: number;
}

export interface ICreateNewCharityArgs extends ReduxAction {
  payload: ICreateCharity;
  isUpdating: boolean;
}

export interface IEnableCharityArgs extends ReduxAction {
  payload: ICharityList;
}

export interface IDeleteCharityArgs extends ReduxAction {
  payload: number;
}

export interface IDeleteCharityResponse extends ReduxAction {
  data: string;
}

export interface IFetchCharityArgs extends ReduxAction {
  page: number;
}

export const fetchCharities = createAsyncThunk(
  CHARITY.LIST,
  async ({ page, onFailure }: IFetchCharityArgs, { rejectWithValue }) => {
    try {
      const { data }: IFetchCharitiesResponse = await axios.get(
        `${CHARITY.LIST}?page=${page}`
      );

      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const fetchCharityDonors = createAsyncThunk(
  CHARITY.DONORS,
  async ({ id, onFailure }: IFetchCharityDonorsArgs, { rejectWithValue }) => {
    try {
      const { data }: any = await axios.get(
        CHARITY.DONORS.replace(":id", String(id))
      );

      return data?.donors;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const createNewCharity = createAsyncThunk(
  CHARITY.CREATE,
  async (
    { payload, isUpdating, onSuccess, onFailure }: ICreateNewCharityArgs,
    { rejectWithValue }
  ) => {
    const newPayload = { ...payload };
    delete newPayload.id;
    const formData = new FormData();
    for (const [key, value] of Object.entries(newPayload)) {
      if (value) {
        formData.append(`${key}`, value as unknown as any);
      }
    }

    try {
      const apiEndpoint = isUpdating
        ? CHARITY.DETAIL.replace(":id", String(payload.id))
        : CHARITY.CREATE;

      const { data }: ICreateCharityResponse = await axios.post(apiEndpoint, formData);

      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const enableCharity = createAsyncThunk(
  `${CHARITY.DETAIL}/enable`,
  async (
    { payload, onSuccess, onFailure }: IEnableCharityArgs,
    { rejectWithValue }
  ) => {
    try {
      const apiEndpoint = CHARITY.DETAIL.replace(":id", String(payload.id));
      const { data }: ICreateCharityResponse = await axios.post(
        apiEndpoint,
        payload
      );

      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const deleteCharity = createAsyncThunk(
  `${CHARITY.DETAIL}/delete`,
  async (
    { payload, onSuccess, onFailure }: IDeleteCharityArgs,
    { rejectWithValue }
  ) => {
    try {
      const apiEndpoint = CHARITY.DETAIL.replace(":id", String(payload));
      const { data }: IDeleteCharityResponse = await axios.delete(apiEndpoint);

      if (onSuccess) onSuccess(data);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
